var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLock = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.25 7.25V5a3.75 3.75 0 1 1 7.5 0v2.25H12c.966 0 1.75.784 1.75 1.75v4A1.75 1.75 0 0 1 12 14.75H4A1.75 1.75 0 0 1 2.25 13V9c0-.966.784-1.75 1.75-1.75zM8 2.75A2.25 2.25 0 0 1 10.25 5v2.25h-4.5V5A2.25 2.25 0 0 1 8 2.75M3.75 9A.25.25 0 0 1 4 8.75h8a.25.25 0 0 1 .25.25v4a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLock);
export default ForwardRef;